import { browserName, fullBrowserVersion, osName, osVersion, isMobile, isTablet } from 'react-device-detect';

export interface BrowserEnvironment {
  appVersion?: string;
  appEnv?: string;
  browser: string;
  os: string;
  device: string;
  screen: string;
  viewport: string;
  dpr: number;
  language: string;
  timezone: string;
  memory?: string;
  cpuCores: number;
  online: boolean;
  cookiesEnabled: boolean;
  network?: string;
  networkDownlink?: string;
  networkRtt?: string;
  referrer?: string;
  navigationEntry?: string;
  url: string;
  timestamp: string;
}

export function captureEnvironment(): BrowserEnvironment {
  const nav = navigator as Navigator & {
    deviceMemory?: number;
    connection?: { effectiveType?: string; downlink?: number; rtt?: number };
  };

  const device = isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Desktop';

  const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;

  return {
    // Inyectada por el `define` de `vite.config.mts`. Ver la nota en `src/index.tsx`.
    appVersion: import.meta.env.VITE_APP_VERSION,
    appEnv: window.REACT_APP_ENV,
    browser: fullBrowserVersion ? `${browserName} ${fullBrowserVersion}` : browserName,
    os: osVersion ? `${osName} ${osVersion}` : osName,
    device,
    screen: `${window.screen.width}×${window.screen.height}`,
    viewport: `${window.innerWidth}×${window.innerHeight}`,
    dpr: window.devicePixelRatio,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    memory: nav.deviceMemory != null ? `${nav.deviceMemory} GB` : undefined,
    cpuCores: navigator.hardwareConcurrency,
    online: navigator.onLine,
    cookiesEnabled: navigator.cookieEnabled,
    network: nav.connection?.effectiveType,
    networkDownlink: nav.connection?.downlink != null ? `${nav.connection.downlink} Mbps` : undefined,
    networkRtt: nav.connection?.rtt != null ? `${nav.connection.rtt} ms` : undefined,
    referrer: document.referrer || undefined,
    navigationEntry: navEntry?.type,
    url: window.location.href,
    timestamp: new Date().toISOString()
  };
}
